import * as Yup from "yup";

// Helper to strip HTML tags from the Quill content
const stripHtml = (html: string) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

export const notificationSchema = Yup.object().shape({
  message: Yup.string()
    .test("is-not-empty", "Message is required", (value) => {
      if (!value) return false;
      const text = stripHtml(value).trim();
      return text.length > 0; // ensure user entered real text, not just <p><br></p>
    })
    .required("Message is required"),

  notificationDate: Yup.date()
    .typeError("Notification date must be a valid date")
    .required("Notification date is required"),

  notificationTime: Yup.string()
    .matches(
      /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
      "Notification time must be a valid time string (HH:mm:ss)"
    )
    .required("Notification time is required"),
});
